import {log,_,moment,mySynchModules} from '../globals.js'
	
var config = mySynchModules.config

interface MySynchCookieOptions {
	expires?: Date;
}
interface MySynchCookie {
	applicationKey: string;
	key: string;
	value: any;
	options?: MySynchCookieOptions;
}

angular.module('mySynch').service('CookieFactory', class CookieFactory {
		
		constructor () {
			this.load();
		}

		private putCookie(cookie) {
			var key = cookie.applicationKey + '-' + cookie.key;

			localStorage.setItem(key, JSON.stringify(cookie));
		}

		private getCookie(cookie) {
			var key = cookie.applicationKey + '-' + cookie.key;
			var itemString = localStorage.getItem(key);

			if (itemString === null) {
				return undefined;
			}

			var item = JSON.parse(itemString);

			if (item.options && item.options.expires && +moment(item.options.expires) < +moment()) {
				localStorage.removeItem(key);

				return undefined;
			}
			
			return item.value;
		}

		private isReserved(cookie) {
			return _.includes(['load', 'save', 'clear'], cookie.key);
		}

		load() {
			
			_.forEach(config.cookies, (configCookie:MySynchCookie) => {
				var cookie = _.extend({}, configCookie) as MySynchCookie;
				//TODO: cookies should specify their default type by a parameter now instead of this 'key[]' form
				var isArray = cookie.key.indexOf('[]') > -1;
				cookie.key = cookie.key.replace(/\[\]$/, '');

				if (this.isReserved(cookie)) {
					log.error('Error: reserved word \'' + cookie.key + '\' cannot be used as cookie name');
				} else {
					cookie.value = this.getCookie(cookie);

					if (_.isUndefined(cookie.value)) {
						cookie.value = isArray ? [] : {};
					}

					this[cookie.key] = cookie.value;
				
				}
			});
		};

		save() {
			_.forEach(config.cookies, (configCookie:MySynchCookie) => {
				var cookie = _.extend({}, configCookie) as MySynchCookie;
				var isArray = cookie.key.indexOf('[]') > -1;
				cookie.key = cookie.key.replace(/\[\]$/, '');

				if (this.isReserved(cookie)) {
					log.error('Error: reserved word \'' + cookie.key + '\' cannot be used as cookie name');
				} else {
					cookie.value = this[cookie.key];

					if (_.isUndefined(cookie.value)) {
						cookie.value = isArray ? [] : {};
					}

					this.putCookie(cookie);
				}
			});
		};

		// Note: If the cookie you want to clear is an array, you will need to append brackets.
		// Example:
		// cookies.clear('dogs[]');
		// cookies.clear('parent');
		// cookies.clear(['parent', 'vet']);
		// cookies.clear();
		clear(key) {
			var cookiesToClear = [];

			if (key) {
				if (!_.isArray(key)) {
					var cookie = {key: key};
					cookiesToClear.push(cookie);
				} else {
					_.forEach(key, function pushKey(key) {
						var cookie =  {key: key};
						cookiesToClear.push(cookie);
					});
				}
			} else {
				cookiesToClear = config.cookies;
			}

			_.forEach(cookiesToClear, (cookie) => {
				var isArray = cookie.key.indexOf('[]') > -1;
				cookie.key = cookie.key.replace(/\[\]$/, '');

				if (this.isReserved(cookie)) {
					log.error('Error: reserved word \'' + cookie.key + '\' cannot be used as cookie name');
				} else {
					this[cookie.key] = isArray ? [] : {};
				}
			});
           
		    this.save();
		};

	});

